module.exports = __webpack_public_path__ + "img/64c5813.jpg";